import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import FromDateModal from './FromDateModal';
const ClaimSelectionFromDateField = _ref => {
  let {
    claim,
    setFromDate
  } = _ref;
  const [modalOpen, setModalOpen] = useState(false);
  if (claim.from_date) return /*#__PURE__*/React.createElement("td", null, createTimezonedDate(claim.from_date).toCustomLocaleDateString());
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FromDateModal, {
    title: "Select From Date",
    show: modalOpen,
    onHide: date => {
      setModalOpen(false);
    },
    onSubmit: date => setFromDate(date, claim)
  }), /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    variant: "primary",
    onClick: () => setModalOpen(true)
  }, "Add From Date"));
};
export default ClaimSelectionFromDateField;